<template lang="pug">
    fragment
        // Arrow
        td
            expand-component(:class="{'expanded' : expanded}")

        // Title
        td {{ item.title }}

        // Actions
        td.px-0.text-xs-right
            slot
</template>

<script>
    import VueTypes from 'vue-types';
    import { mapActions } from 'vuex';
    import ListItemActions from './ListItemActions';
    import ExpandIcon from '~components/ExpandIcon';

    export default {
        components: {
            ExpandComponent: ExpandIcon,
            ItemActions: ListItemActions
        },
        props: {
            item: VueTypes.object.def({}),
            expanded: VueTypes.bool.def(false)
        },
        methods: {
            ...mapActions('coupons', ['delete', 'getCoupons']),

            /**
             * Delete coupon.
             * @returns {Promise<void>}
             */
            async remove() {
                const resp = await this.delete(this.item.id);

                if (resp) {
                    this.getCoupons();
                }
            }
        }
    };
</script>
